@if (egid && hasExternalGwr) {
  <a
    [href]="externerGwrLink"
    [ngbTooltip]="'gwr-link.tooltip' | translate: { egid: egid }"
    class="link-icon"
    rel="noreferrer noopener"
    target="_blank">
    <i class="fas fa-external-link-alt"></i>
  </a>
}
